<template>
  <div class="CartPrice" :class="{hasPaymentMethod: paimentMethods}">
    
    <div v-if="specialPrice" class="CartPrice-container">
      
      <!-- Devider 1st payment -->
      <p v-if="devider && devider > 1 && firstPayment" class="priceBig" :inner-html.prop="firstPayment | formatPrice(2)"></p>
      <!-- Else Price -->
      <p v-else class="priceBig" :inner-html.prop="specialPrice | formatPrice(2)"></p>
      
      <small class="ttc" :class="{devided: devider && devider > 1}">
        <span v-if="devider && devider > 1 && monthlyPayment" >puis {{ devider - 1 }} X 
          <span :inner-html.prop="monthlyPayment | formatPrice(2)"></span>
        </span> 
        TTC
      </small>
      
      <div v-if="originalPrice > specialPrice" class="CartPrice-specialPrice">
        <p :inner-html.prop="originalPrice | formatPrice(2)"></p>
      </div>
    </div>
    
    <div v-else class="CartPrice-container no-spe">
      <!-- Devider 1st payment -->
      <p v-if="devider && devider > 1 && firstPayment" class="priceBig" :inner-html.prop="firstPayment | formatPrice(2)"></p>
      <!-- Else Price -->
      <p v-else class="priceBig" :inner-html.prop="originalPrice | formatPrice(2)"></p>
      
      <small class="ttc" :class="{devided: devider && devider > 1}">
        <span v-if="devider && devider > 1 && monthlyPayment" >puis {{ devider - 1 }} X 
          <span :inner-html.prop="monthlyPayment | formatPrice(2)"></span>
        </span> 
        TTC
      </small>
    </div>
    
    <p v-if="ecoTaxe > 0" class="CartPrice-eco">
      dont <span :inner-html.prop="ecoTaxe | formatNumber(1)"></span>€ d'écotaxe
    </p>
  </div>
</template>

<script>
import "@/includes/Cart/CartPrice/CartPrice.scss";
import EventBus from "@/event-bus";

import availablePaimentMethodsMixin from "@/mixins/actions/paiment/getAvailablePaimentMethodsMixin";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CartPrice",

  data() {
    return {
      firstPayment: null,
      monthlyPayment: null,
      paymentMethods: null,
    }
  },

  mixins: [availablePaimentMethodsMixin],

  // Map Actions
  ...mapActions(["setChoosenPaymentMethod"]),

  computed: {
      ...mapGetters({ choosenMethod: "getChoosenPaymentMethod" }),        
  },

  methods: {
    async updatePayments(paymentMethod) {
      if(paymentMethod && paymentMethod['schedule'] && paymentMethod['schedule'][0]) {
        this.firstPayment = paymentMethod['schedule'][0]['amount'];
        this.monthlyPayment = paymentMethod['schedule'][1] ? paymentMethod['schedule'][1]['amount'] : null;
      } else {
        await this.getAvailablePaimentMethods();
        this.updatePaymentsMethod();
        this.updatePaymentsAmounts();
      }
    },

    updatePaymentsMethod() {
      let isDevider = this.devider && this.devider > 1;
      if(isDevider && (this.paimentMethods && this.paimentMethods[this.devider - 1])) {
        
        this.$store.dispatch("setChoosenPaymentMethod", this.paimentMethods[this.devider - 1]);
      }
    },

    updatePaymentsAmounts() {
      let isDevider = this.devider && this.devider > 1;
      
      if(isDevider && (this.choosenMethod['schedule'] && this.choosenMethod['schedule'][0]) && !this.isProductPage) {
        this.firstPayment = this.choosenMethod['schedule'][0]['amount'];
        this.monthlyPayment = this.choosenMethod['schedule'][1]['amount'];
      } else {       
        this.firstPayment = this.specialPrice;
        this.monthlyPayment = (this.specialPriceTotal - this.specialPrice) / (this.devider - 1);
      }  
    }
  
  },

  async mounted() {
    EventBus.$on("update-tva", (paymentMethod) => this.updatePayments(paymentMethod));
    EventBus.$on("update-installments", () => this.updatePayments());
  },

  updated() {
    /* this.updatePaymentsMethod();
    this.updatePaymentsAmounts(); */
  },

  props: {
    originalPrice: {
      type: [String, Number],
      required: true,
      default: 0,
    },
    specialPrice: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    devider: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    ecoTaxe: {
      type: [String, Number],
      required: true,
    },
    specialPriceTotal: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    isProductPage: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
